(
    function (skyward, $, undefined)
    {
        skyward.displayperiodcheckboxgrid = skyward.displayperiodcheckboxgrid || {};

        var bottomWrapperID = "#DisplayPeriodCheckboxGrid";

        var init = function (selector)
        {
            if (!$(selector).find(bottomWrapperID).get(0))
            {
                return;
            }
        };

        skyward.displayperiodcheckboxgrid.dayRotationCheckboxClicked = function (target)
        {
            var dayCheckBox = $(target);
            var displayPeriodCodeAlias = dayCheckBox.data("display-period-code-alias");

            var varDayCheckValues = checkDayCheckboxesAllSelected(displayPeriodCodeAlias)
            updateAllCheckbox(displayPeriodCodeAlias, varDayCheckValues.allChecked);
            toggleIsPrimaryRadioButton(displayPeriodCodeAlias, !varDayCheckValues.atLeastOneChecked);
        };

        var updateAllCheckbox = function (displayPeriodCodeAlias, enabled)
        {
            var allCheckbox = $("#checkAll-" + displayPeriodCodeAlias);
            skyward.controls.setValue(allCheckbox, enabled);
        }

        var checkDayCheckboxesAllSelected = function (displayPeriodCodeAlias)
        {
            var row = getRow(displayPeriodCodeAlias);
            var allChecked = true;
            var atLeastOneChecked = false;
            row.find(".checkboxDay" + displayPeriodCodeAlias).each(function (index, element)
            {
                var checked = skyward.controls.getValue(element);
                if (!checked)
                {
                    allChecked = false;
                }
                else
                {
                    atLeastOneChecked = true;
                }
            });

            return {"allChecked": allChecked, "atLeastOneChecked": atLeastOneChecked };
        }

        var updateDayRotationCheckboxes = function (displayPeriodCodeAlias, checked)
        {
            var row = getRow(displayPeriodCodeAlias);
            row.find(".checkboxDay" + displayPeriodCodeAlias).each(function (index, element)
            {
                skyward.controls.setValue(element, checked);
            });
        }

        var toggleIsPrimaryRadioButton = function (displayPeriodCode, disable)
        {
            var radioButton = $("#checkbox--PrimaryDisplayPeriod-" + displayPeriodCode + " > input.radioButtonContent");
            if (disable)
            {
                skyward.controls.disable(radioButton);
                if (radioButton.prop("checked") == true)
                {
                    radioButton.prop("checked", false);
                    findFirstPrimaryEnabledToSelect();
                }
            }
            else
            {
                skyward.controls.enable(radioButton);
                if (!radioButton.prop("checked"))
                {
                    radioButton.prop("checked", checkIsPrimary());
                }
            }
        }

        var findFirstPrimaryEnabledToSelect = function ()
        {
            var newPrimarySelected = false;
            $(bottomWrapperID).find("input.radioButtonContent").each(function (index, element)
            {
                var radioButton = $(element);
                if (!newPrimarySelected && !radioButton.prop("disabled"))
                {
                    newPrimarySelected = true;
                    radioButton.prop("checked", true);
                }
            });
        }

        var checkIsPrimary = function ()
        {
            var oneChecked = false;
            $(bottomWrapperID).find("input.radioButtonContent").each(function (index, element)
            {
                var radioButton = $(element);
                if (!oneChecked && !radioButton.prop("disabled") && radioButton.prop("checked"))
                {
                    oneChecked = true;
                }
            });

            return !oneChecked;
        }

        var getRow = function (displayPeriodCodeAlias)
        {
            return $("#row-" + displayPeriodCodeAlias);
        }

        skyward.displayperiodcheckboxgrid.allCheckboxClicked = function (target)
        {
            var allCheckbox = $(target);
            var allCheckBoxChecked = skyward.controls.getValue(allCheckbox);
            var displayPeriodCodeAlias = allCheckbox.data("display-period-code-alias");

            updateDayRotationCheckboxes(displayPeriodCodeAlias, allCheckBoxChecked);
            toggleIsPrimaryRadioButton(displayPeriodCodeAlias, !allCheckBoxChecked);
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
